import { SVGProps } from "react";

export const StarCircleSVG = ({
  color = "#FFF500",
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5152 4.69477C13.0698 3.36841 11.1302 3.36842 10.6848 4.69477L9.38786 8.5564H5.19092C3.74939 8.5564 3.15005 10.341 4.31625 11.1607L7.71166 13.5473L6.41473 17.409C5.96928 18.7353 7.53841 19.8383 8.70461 19.0185L12.1 16.6319L15.4954 19.0185C16.6616 19.8383 18.2308 18.7353 17.7853 17.409L16.4884 13.5473L19.8837 11.1607C21.0499 10.341 20.4507 8.5564 19.0092 8.5564H14.8122L13.5152 4.69477Z"
      fill={color}
      stroke="#F3612D"
      strokeWidth="1.5"
    />
    <circle cx="12" cy="12" r="11.7" stroke="#FCDBD8" />
  </svg>
);
